import { z } from 'zod';
import { timestampSchema } from './shared';

export const auditLogRowSchema = z.object({
  id: z.string().min(1),
  actorId: z.string().nullable(),
  actorEmail: z.string().nullable(),
  action: z.string().min(1),
  targetType: z.string().nullable(),
  targetId: z.string().nullable(),
  metadata: z.unknown().nullable(),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: timestampSchema,
});

export type AuditLogRow = z.infer<typeof auditLogRowSchema>;
